import type { ExportState } from '@/api/reports'
import { Badge, type BadgeTone } from '@/design'

const EXPORT_STATE: Record<ExportState, { tone: BadgeTone; label: string }> = {
  queued: { tone: 'accent', label: 'Queued' },
  ready: { tone: 'positive', label: 'Ready' },
  expired: { tone: 'neutral', label: 'Expired' },
}

export function ExportStateBadge({ state }: { state: ExportState }) {
  const { tone, label } = EXPORT_STATE[state]
  return <Badge tone={tone}>{label}</Badge>
}
